
define('text!templates/base/collection.html',[],function () { return '<div class="pull-left m-t-10">\n    <input type="text" class="form-control pull-left search-table" spellcheck="false" placeholder="<%= App.polyglot.t(\'search\') %>" value="<%= searchQuery %>">\n</div>\n<div class="clearfix"></div>\n\n<div class="list-container">\n\n</div>';});

